export default __webpack_public_path__ + "static/media/2060-digital-logo.6ccd66ca.svg";